import { jsx as _jsx } from "react/jsx-runtime";
import { memo } from 'react';
import classnames from 'classnames';
import SpinnerIcon from '../../assets/icons/spinner.svg';
import styles from './Spinner.css';
export const Spinner = memo(function Spinner({ className, testId, }) {
    return (_jsx(SpinnerIcon, { className: classnames(styles.spinner, className), "data-testid": testId }, void 0));
});
